import { ReviewFormSource } from "@faire/web--source/common/consts/REVIEW_FORM_SOURCES";
import React from "react";
var DEFAULT_SOURCE = ReviewFormSource.brand_review_source_unknown;
export var BrandOrderReviewPageNavigationSourceContext = React.createContext(DEFAULT_SOURCE);
export var useBrandOrderReviewPageNavigationSourceContext = function() {
    return React.useContext(BrandOrderReviewPageNavigationSourceContext);
};
